import React, { Suspense, lazy, Fragment } from "react";
import Loading from "../components/loading/Loading";
import PrivateRoute from "./privateRoute/PrivateRoute";

// school_it
const SchoolSetup = lazy(() => import("../features/school_it/schoolSetup/SchoolSetup"));
const GlobalGoal = lazy(() => import("../features/school_it/globalGoal/GlobalGoal"));
const SchoolitProfile = lazy(() => import("../features/school_it/profile/SchoolitProfile"));
const StudentStatistics = lazy(() => import("../features/school_it/studentStatistics/StudentStatistics"));
const Student = lazy(() => import("../features/school_it/student/Student"));
const CSVImport = lazy(() => import("../features/school_it/csvImport/CsvImport"));
const DownloadStudentSummary = lazy(() => import("../features/school_it/downloadStudentSummary/DownloadStudentSummary"));
const MaintainGroup = lazy(() => import("../features/school_it/maintainGroup/MaintainGroup"));
const SchoolITStudentMessage = lazy(() => import("../features/school_it/studentMessage/StudentMessage"));
const MessageCenter = lazy(() => import("../features/school_it/messageCenter/MessageCenter"));
const GroupMessage = lazy(() => import("../features/school_it/groupMessage/GroupMessage"));
const GoalCriteriaOrSetup = lazy(() => import("../features/school_it/goalCriteriaOrSetup/GoalCriteriaOrSetup"));
const ViewRequiredCourseSet = lazy(() => import("../features/school_it/goalCriteriaOrSetup/viewRequiredCourseSet/ViewRequiredCourseSet"));
const MapCourseData = lazy(() => import("../features/school_it/goalCriteriaOrSetup/mapCourseData/MapCourseData"));
const CreateGoalMap = lazy(() => import("../features/school_it/goalCriteriaOrSetup/createGoalMap/CreateGoalMap"));
const ManageDataSource = lazy(() => import("../features/school_it/goalCriteriaOrSetup/manageDataSource/ManageDataSource"));
const CreateDataSource = lazy(() => import("../features/school_it/goalCriteriaOrSetup/createDataSource/CreateDataSource"));
const UploadDataSource = lazy(() => import("../features/school_it/goalCriteriaOrSetup/uploadDataSource/UploadDataSource"));
const MapCollege = lazy(() => import("../features/school_it/goalCriteriaOrSetup/mapCollege/MapCollege"));
const MapGoal = lazy(() => import("../features/school_it/goalCriteriaOrSetup/mapGoal/MapGoal"));

// recruiter
const Profile = lazy(() => import("../features/recruiter/recruiterprofile/Profile.js"));
const Query = lazy(() => import("../features/recruiter/query/Query"));
const Message = lazy(() => import("../features/recruiter/message/Message"));
const SchoolQuery = lazy(() => import("../features/recruiter/schoolquery/SchoolQuery"));
const CollegeQuery = lazy(() => import("../features/recruiter/collegequery/CollegeQuery"));
const QueryResultCCCComponent = lazy(() => import("../features/recruiter/queryresult/QueryResultCCC"));
const QueryResultComponent = lazy(() => import("../features/recruiter/queryresult/QueryResult"));
const MessageTemplate = lazy(() => import("../features/recruiter/messageTemplate/MessageTemplate"));
const SavedQuery = lazy(() => import("../features/recruiter/savedquery/SavedQuery"));
const DigitalCampaign = lazy(() => import("../features/recruiter/digitalCampaign/DigitalCampaign"));

// admin
const Import = lazy(() => import("../features/admin/import/Import"));
const CannedMessages = lazy(() => import("../features/admin/cannedMessages/CannedMessages"));
const SchoolitProfiles = lazy(() => import("../features/school_it/profile/SchoolitProfile"));
const Statistics = lazy(() => import("../features/admin/statistics/Statistics"));
const LoginAnalytics = lazy(() => import("../features/admin/loginAnalytics/LoginAnalytics"));
const Invites = lazy(() => import("../features/admin/invites/Invites"));
const School = lazy(() => import("../features/admin/school/School"));
const Students = lazy(() => import("../features/admin/student/Student"));
const Counselors = lazy(() => import("../features/admin/counselors/Counselors"));
const Teachers = lazy(() => import("../features/admin/teachers/Teachers"));
const UpdateGoalsForSchools = lazy(() => import("../features/admin/updateGoalsForSchools/UpdateGoalsForSchools"));
const CreateSchoolIt = lazy(() => import("../features/admin/createSchoolIt/CreateSchoolIt"));
const ConfigurationList = lazy(() => import("../features/admin/configurationList/ConfigurationList"));
const Colleges = lazy(() => import("../features/admin/colleges/Colleges"));
const Recruiters = lazy(() => import("../features/admin/recruiters/Recruiters"));
const ContractSetup = lazy(() => import("../features/admin/contractSetup/ContractSetup"));
const StudentProgress = lazy(() => import("../features/admin/studentProgress/StudentProgress"));
// import Searches from "../components/admin/searches/Searches";
const CreateCannedMessages = lazy(() => import("../features/admin/cannedMessages/CreateCannedMessages"));
const CreateGoal = lazy(() => import("../features/admin/studentProgress/createGoal/CreateGoal"));
const RequiredGoal = lazy(() => import("../features/admin/studentProgress/requiredGoal/RequiredGoal"));
const SftpDetails = lazy(() => import("../features/admin/sftpDetails/SftpDetails.js"));
const MessagesApproval = lazy(() => import("../features/admin/messagesApproval/MessagesApproval"));
const MyCurriculum = lazy(() => import("../features/student/myCurriculum/MyCurriculum.js"));
const MyCurriculumCurriculumUpload = lazy(() => import("../features/student/myCurriculum/MyCurriculumUpload.js"));
const QueryResultInternationalComponent = lazy(() => import("../features/recruiter/queryresult/QueryResultInternational.js"));
const ExportResultRecruiter = lazy(() => import("../features/admin/exportResultRecruiter/ExportResultRecruiter.js"));
const StudentReflection = lazy(() => import("../features/student/studentReflection/StudentReflection.js"));

// import Storage from "../services/Storage";

// need to remove
const Dashboard = lazy(() => import("../features/student/dashboard/Dashboard"));
const BrownDashboard = lazy(() => import("../features/student/dashboard/BrownDashboard"));

const Goals = lazy(() => import("../features/student/goals/Goals"));
const Portfolio = lazy(() => import("../features/student/portfolio/Portfolio"));
const MyPassion = lazy(() => import("../features/student/myPassion/MyPassion"));
const StudentChecklist = lazy(() =>
import("../features/student/studentChecklist/StudentChecklist")
);
const StudentCalendar = lazy(() =>
import("../features/student/studentCalendar/StudentCalendar")
);
const StudentProfile = lazy(() =>
import("../features/student/studentProfile/StudentProfile")
);
const StudentMessage = lazy(() =>
import("../features/student/studentMessage/StudentMessage")
);
const Websites = lazy(() => import("../features/student/collegeLink/CollegeLink"));

const ChildRegistration = lazy(() =>
import("../features/parent/childRegistration/ChildRegistration")
);
const PersonalNotes = lazy(() => import("../features/student/personalNotes/PersonalNotes"));




// Parent
const ParentProfile = lazy(() =>
import("../features/parent/parentProfile/ParentProfile")
);
const ParentLadder = lazy(() =>
import("../features/parent/parentLadder/ParentLadder")
);
const ParentPassion = lazy(() =>
import("../features/parent/parentPassion/ParentPassion")
);
const ParentPortfolio = lazy(() =>
import("../features/parent/parentPortfolio/ParentPortfolio")
);
const ParentMessage = lazy(() =>
import("../features/parent/parentMessage/ParentMessage")
);
const ParentGoal = lazy(() => import("../features/parent/parentGoal/ParentGoal"));
const StudentCourseDetail = lazy(() =>
import("../features/parent/parentGoal/studenCoursetDetail/StudenCoursetDetail")
);

// Counselor
const Profiles = lazy(() => import("../features/recruiter/recruiterprofile/Profile"));
const CounselorCollegeConnectStudent = lazy(() => import("../features/counselor/counselorCollegeConnectStudent/CounselorCollegeConnectStudent"));
const ManageStudent = lazy(() => import("../features/counselor/manageStudent/ManageStudent"));
const CounselorStudentDetail = lazy(() => import("../features/counselor/counselorStudentDetail/CounselorStudentDetail"));

const ManageGroupList = lazy(() => import("../features/counselor/manageGroupList/ManageGroupList"));
const CurrentStudent = lazy(() => import("../features/counselor/currentStudent/CurrentStudent"));
const InviteStudent = lazy(() => import("../features/counselor/inviteStudent/InviteStudent"));
const AddExistingStudent = lazy(() => import("../features/counselor/addExistingStudent/AddExistingStudent"));
const ImportFiles = lazy(() => import("../features/counselor/importFiles/ImportFiles"));
const CounselorAllMessage = lazy(() => import("../features/counselor/allMessage/AllMessage"));
const CounselorStudentMessage = lazy(() => import("../features/counselor/counselorStudentMessage/StudentMessage"));
const CounselorCalendar = lazy(() => import("../features/counselor/counselorCalendar/CounselorCalendar"));
const CounselorDeleteMessage = lazy(() => import("../features/counselor/deleteMessage/DeleteCounselorMessage"));
const RecruiterDeleteMessage = lazy(() => import("../features/recruiter/deleteMessage/DeleteRecruiterMessage"));
const DownLoadSummary = lazy(() => import("../features/superCounselor/downloadSummary/DownloadSummary"));
const CounselorMessageTemplate = lazy(() => import("../features/superCounselor/counselorMessageTemplate/CounselorMessageTemplate"));

// Teacher
const TeacherMySubjects = lazy(() => import("../features/teacher/MySubjects"));
const TeacherSubjectStudents = lazy(() => import("../features/teacher/SubjectStudents"));
const TeacherGoalProgress = lazy(() => import("../features/teacher/TeacherGoalProgress"));
const TeacherMessages = lazy(() => import("../features/teacher/TeacherMessages"));

const suspenseRoutesArr = [
// {
//   path: "/dashboard",
//   component: "",
//   header: true,
//   sidebar: true,
// },
{
  path: "/student/dashboard",
  component: Dashboard,
  header: true,
  sidebar: true
},
{
  path: "/student/brown-dashboard",
  component: BrownDashboard,
  header: true,
  sidebar: true
},
{
  path: "/student/goal/cc-requirement",
  component: Goals,
  header: true,
  sidebar: true
},
{
  path: "/student/goal/csu-requirement",
  component: Goals,
  header: true,
  sidebar: true
},
{
  path: "/student/goal/uc-requirement",
  component: Goals,
  header: true,
  sidebar: true
},
{
  path: "/student/curriculum",
  component: MyCurriculum,
  header: true,
  sidebar: true
},
{
  path: "/student/curriculum-upload",
  component: MyCurriculumCurriculumUpload,
  header: true,
  sidebar: true
},
{
  path: "/student/interest",
  component: MyPassion,
  header: true,
  sidebar: true
},
{
  path: "/student/portfolio/:linkParam?",
  component: Portfolio,
  header: true,
  sidebar: true
},
{
  path: "/student/profile",
  component: StudentProfile,
  header: true,
  sidebar: true
},
{
  path: "/student/my-colleges",
  component: Websites,
  header: true,
  sidebar: true
},
{
  path: "/student/calendar",
  component: StudentCalendar,
  header: true,
  sidebar: true
},
{
  path: "/student/message",
  component: StudentMessage,
  header: true,
  sidebar: true
},
{
  path: "/student/reflections",
  component: StudentReflection,
  header: true,
  sidebar: true
},
{
  path: "/student/personal-notes",
  component: PersonalNotes,
  header: true,
  sidebar: true
},

{
  path: "/student/ladder",
  component: StudentChecklist,
  header: true,
  sidebar: true
},
// Parent Role
{
  path: "/parent/goal/cc-requirement",
  // component: Parents,
  component: ParentGoal,
  header: true,
  sidebar: true
},
{
  path: "/parent/goal/csu-requirement",
  // component: Parents,
  component: ParentGoal,
  header: true,
  sidebar: true
},
{
  path: "/parent/goal/uc-requirement",
  // component: Parents,
  component: ParentGoal,
  header: true,
  sidebar: true
},
{
  path: "/parent/goal/student-course-detail",
  component: StudentCourseDetail,
  header: true,
  sidebar: true
},
{
  path: "/parent/interest",
  component: ParentPassion,
  header: true,
  sidebar: true
},
{
  path: "/parent/portfolio/:linkParam?",
  component: ParentPortfolio,
  header: true,
  sidebar: true
},

{
  path: "/parent/message",
  component: ParentMessage,
  header: true,
  sidebar: true
},
{
  path: "/parent/personal-notes",
  component: PersonalNotes,
  header: true,
  sidebar: true
},
{
  path: "/parent/reflections",
  component: StudentReflection,
  header: true,
  sidebar: true
},
{
  path: "/parent/ladder",
  component: ParentLadder,
  header: true,
  sidebar: true
},
{
  path: "/parent/profile",
  component: ParentProfile,
  header: true,
  sidebar: true
},
{
  path: "/parent/my-colleges",
  component: Websites,
  header: true,
  sidebar: true
},
{
  path: "/parent/child-registration",
  component: ChildRegistration,
  header: true,
  sidebar: true
},
// Teacher Routes
{
  path: "/teacher/class/:classId",
  component: TeacherSubjectStudents,
  header: true,
  sidebar: true
},
{
  path: "/teacher/my-subjects",
  component: TeacherMySubjects,
  header: true,
  sidebar: true
},
{
  path: "/teacher/goal-progress",
  component: TeacherGoalProgress,
  header: true,
  sidebar: true
},
{
  path: "/teacher/messages",
  component: TeacherMessages,
  header: true,
  sidebar: true
},
{
  path: "/teacher/profile",
  component: Profiles,
  header: true,
  sidebar: true
},
{
  // exact: true,
  path: "/counselor/profile",
  component: Profiles,
  //key: "Profile",
  header: true,
  sidebar: true
},
{
  //exact: true,
  path: "/counselor/student-list",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/counselor/all-students",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  //exact: true,
  path: "/counselor/on-track-student",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  //exact: true,
  path: "/counselor/at-risk-student",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  //exact: true,
  path: "/counselor/off-track-student",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  //exact: true,
  path: "/counselor/at-brown-student",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  //exact: true,
  path: "/counselor/watchlist",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/manage",
  component: ManageStudent,
  //key: "ManageStudent",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/student/status",
  component: CounselorStudentDetail,
  //key: "CounselorStudentDetail",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/student/all-message",
  component: CounselorStudentDetail,
  //key: "CounselorStudentDetail",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/message/recruiter-message",
  component: CounselorStudentMessage,
  //key: "CounselorStudentDetail",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/message/group-message",
  component: CounselorStudentMessage,
  //key: "CounselorGroupMessage",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/message/mange-group-list",
  component: ManageGroupList,
  //key: "ManageGroupList",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/message/deleted-message",
  component: CounselorDeleteMessage,
  //key: "CounselorDeleteMessage",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/message/approved-group-message",
  component: CounselorStudentMessage,
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/current-student",
  component: CurrentStudent,
  //key: "CurrentStudent",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/invite-student",
  component: InviteStudent,
  //key: "InviteStudent",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/add-existing-student",
  component: AddExistingStudent,
  //key: "AddExistingStudent",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/export-file",
  component: ImportFiles,
  //key: "ImportFiles",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/message/all-message",
  component: CounselorAllMessage,
  //key: "CounselorAllMessage",
  header: true,
  sidebar: true
},

{
  //exact: false,
  path: "/counselor/message/student-message",
  component: CounselorStudentMessage,
  //key: "CounselorStudentMessage",
  header: true,
  sidebar: true
},
{
  path: "/counselor/message/parent-message",
  component: CounselorStudentMessage,
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/counselor/calendar",
  component: CounselorCalendar,
  //key: "CounselorCalendar",
  header: true,
  sidebar: true
},

//Super-Counselor Routes
{
  // exact: true,
  path: "/super_admin/profile",
  component: Profiles,
  //key: "Profile",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/super_admin/all-students",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/student/status",
  component: CounselorStudentDetail,
  //key: "CounselorStudentDetail",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/message/student-message",
  component: CounselorStudentMessage,
  //key: "CounselorStudentMessage",
  header: true,
  sidebar: true
},
{
  path: "/super_admin/message/parent-message",
  component: CounselorStudentMessage,
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/message/recruiter-message",
  component: CounselorStudentMessage,
  //key: "CounselorStudentMessage",
  header: true,
  sidebar: true
},

{
  //exact: true,
  path: "/super_admin/on-track-student",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
// {
//   //exact: true,
//   path: "/super_admin/at-risk-student",
//   component: CounselorCollegeConnectStudent,
//   //key: "CounselorCollegeConnectStudent",
//   header: true,
//   sidebar: true,
// },
{
  //exact: true,
  path: "/super_admin/off-track-student",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  //exact: true,
  path: "/super_admin/at-risk-student",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  //exact: true,
  path: "/super_admin/at-brown-student",
  component: CounselorCollegeConnectStudent,
  //key: "CounselorCollegeConnectStudent",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/current-student",
  component: CurrentStudent,
  //key: "CurrentStudent",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/invite-student",
  component: InviteStudent,
  //key: "InviteStudent",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/add-existing-student",
  component: AddExistingStudent,
  //key: "AddExistingStudent",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/export-file",
  component: ImportFiles,
  //key: "ImportFiles",
  header: true,
  sidebar: true
},
// {
//   //exact: false,
//   path: "/super_admin/message/all-message",
//   component: CounselorAllMessage,
//   //key: "SuperCounselorAllMessage",
//   header: true,
//   sidebar: true,
// },
{
  //exact: false,
  path: "/super_admin/calendar",
  component: CounselorCalendar,
  //key: "CounselorCalendar",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/student_statistics",
  component: DownLoadSummary,
  //key: "DownLoadSummary",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/message/group-message",
  component: CounselorStudentMessage,
  //key: "CounselorStudentMessage",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/message/message-template",
  component: CounselorMessageTemplate,
  //key: "CounselorMessageTemplate",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/message/mange-group-list",
  component: ManageGroupList,
  //key: "ManageGroupList",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/message/deleted-message",
  component: CounselorDeleteMessage,
  //key: "CounselorDeleteMessage",
  header: true,
  sidebar: true
},
{
  //exact: false,
  path: "/super_admin/message/approved-group-message",
  component: CounselorStudentMessage,
  header: true,
  sidebar: true
},

// recruiter
{
  exact: true,
  path: "/recruiter/search-query",
  component: Query,
  //key: "CounselorDeleteMessage",
  header: true,
  sidebar: true
},

{
  exact: true,
  path: "/recruiter/school-query",
  component: SchoolQuery,
  //key: "CounselorDeleteMessage",
  header: true,
  sidebar: true
},

{
  exact: true,
  path: "/recruiter/students",
  component: Message,
  key: "Message",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/parents",
  component: Message,
  key: "Message",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/international-students",
  component: Message,
  key: "Message",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/counselors",
  component: Message,
  key: "Message",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/approved-group-messages",
  component: Message,
  key: "Message",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/deleted-messages",
  component: RecruiterDeleteMessage,
  key: "RecruiterDeleteMessage",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/query-result",
  component: QueryResultComponent,
  key: "QueryResultComponent",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/query-result-college-query",
  component: QueryResultCCCComponent,
  key: "QueryResultCCCComponent",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/query-result-international-query",
  component: QueryResultInternationalComponent,
  key: "QueryInternationalComponent",
  header: true,
  sidebar: true
},


{
  exact: true,
  path: "/recruiter/college-query",
  component: CollegeQuery,
  key: "CollegeQuery",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/saved-query",
  component: SavedQuery,
  key: "SavedQuery",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/profile",
  component: Profile,
  key: "Profile",
  header: true,
  sidebar: true
},
// Recruiter Calendar - reuse CounselorCalendar component
{
  exact: true,
  path: "/recruiter/calendar",
  component: CounselorCalendar,
  key: "CounselorCalendar",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/campaign",
  component: DigitalCampaign,
  key: "DigitalCampaign",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/recruiter/canned",
  component: MessageTemplate,
  key: "MessageTemplate",
  header: true,
  sidebar: true
},

//School It Routes
{
  exact: false,
  path: `/school_it/school_setup`,
  component: SchoolSetup,
  key: "SchoolSetup",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/school_it/global_goal`,
  component: GlobalGoal,
  key: "GlobalGoal",
  header: true,
  sidebar: true
},
// {
//   exact: false,
//   path: `/school_it/sftp_process`,
//   component: SFTPProcess,
//   key: "SFTPProcess",
//   header: true,
//   sidebar: true,
// },
{
  exact: false,
  path: `/school_it/profile`,
  component: SchoolitProfile,
  key: "SchoolitProfile",
  header: true,
  sidebar: true
},
{
  exact: true,
  path: "/school_it/student_statistics",
  component: StudentStatistics,
  key: "StudentStatistics",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/students",
  component: Student,
  key: "Student",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/csv_export",
  component: CSVImport,
  key: "CSVImport",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/calendar",
  component: CounselorCalendar,
  key: "CounselorCalendar",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/dowload_student_status",
  component: DownloadStudentSummary,
  key: "DownloadStudentSummary",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/maintain_group",
  component: MaintainGroup,
  key: "MaintainGroup",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/message-students",
  component: SchoolITStudentMessage,
  key: "SchoolITStudentMessage",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/message_center",
  component: MessageCenter,
  key: "MessageCenter",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/message-groups",
  component: GroupMessage,
  key: "GroupMessage",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/ccplus",
  component: GoalCriteriaOrSetup,
  key: "GoalCriteriaOrSetup",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/course",
  component: ViewRequiredCourseSet,
  key: "ViewRequiredCourseSet",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/mapcourse",
  component: MapCourseData,
  key: "MapCourseData",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/goal",
  component: CreateGoalMap,
  // component: ViewGoalMap,
  key: "ViewGoalMap",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/create_goal",
  component: CreateGoalMap,
  key: "CreateGoalMap",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/manageDataSource",
  component: ManageDataSource,
  key: "ManageDataSource",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/createDataSource",
  component: CreateDataSource,
  key: "CreateDataSource",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/uploadDataSource",
  component: UploadDataSource,
  key: "UploadDataSource",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/mapcollege",
  component: MapCollege,
  key: "MapCollege",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/school_it/mapgoal",
  component: MapGoal,
  key: "MapGoal",
  header: true,
  sidebar: true
},

//admin routes
{
  exact: false,
  path: `/admin/profile`,
  component: SchoolitProfiles,
  key: "SchoolitProfiles",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/export-students`,
  component: Import,
  key: "Import",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/statistics`,
  component: Statistics,
  key: "Statistics",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/login-analytics`,
  component: LoginAnalytics,
  key: "LoginAnalytics",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/nudges-approval`,
  component: MessagesApproval,
  key: "NudgesApproval",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/sftp-info`,
  component: SftpDetails,
  key: "SFTPDetails",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/ccplus`,
  component: StudentProgress,
  key: "StudentProgress",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/admin/goal",
  component: CreateGoal,
  key: "CreateGoalMap",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: "/admin/course",
  component: RequiredGoal,
  key: "ViewRequiredCourseSet",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/send-invites`,
  component: Invites,
  key: "Invites",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/school`,
  component: School,
  key: "School",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/students`,
  component: Students,
  key: "Students",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/counselors`,
  component: Counselors,
  key: "Counselors",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/teachers`,
  component: Teachers,
  key: "Teachers",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/canned`,
  component: CannedMessages,
  key: "CannedMessages",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/canned-mesage`,
  component: CreateCannedMessages,
  key: "Import",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/update_schoolgoals`,
  component: UpdateGoalsForSchools,
  key: "UpdateGoalsForSchools",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/addschool_it`,
  component: CreateSchoolIt,
  key: "CreateSchoolIt",
  header: true,
  sidebar: true
},
// {
//   exact: false,
//   path: `/admin/students_without_counselor`,
//   component: WithoutCounselor ,
//   key: "WithoutCounselor",
//   header: true,
//   sidebar: true,
// },
{
  exact: false,
  path: `/admin/students_without_counselor`,
  component: Students,
  key: "WithoutCounselor",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/configuration`,
  component: ConfigurationList,
  key: "ConfigurationList",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/college`,
  component: Colleges,
  key: "Colleges",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/recruiters`,
  component: Recruiters,
  key: "Recruiters",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/exportResultReport`,
  component: ExportResultRecruiter,
  key: "ExportResultRecruiter",
  header: true,
  sidebar: true
},
{
  exact: false,
  path: `/admin/contractSetup`,
  component: ContractSetup,
  key: "ContractSetup",
  header: true,
  sidebar: true
}
// {
//   exact: false,
//   path: `/admin/search-query`,
//   component: Searches,
//   key: "Searches",
//   header: true,
//   sidebar: true,
// },
];

const PrivateRoutes = () => {
  return (
    <Fragment>
      <>
        {suspenseRoutesArr.map((route, i) =>
        <Suspense fallback={<Loading />} key={i}>
            <PrivateRoute
            path={route.path}
            component={route.component}
            // header={route.header}
            // sidebar={route.sidebar}
          />
          </Suspense>
        )}
      </>
    </Fragment>);

};

export default PrivateRoutes;

// const mapStateToProps = (state) => ({
//   auth: state.Auth.auth,
// });

// const mapDispatchToProps = (dispatch) => ({});

// export default connect(
//   mapStateToProps,
//   mapDispatchToProps
// )(PrivateRoutes);